export default __webpack_public_path__ + "static/media/334.32a12f8f.png";